import { BeforeInsert, Column, Entity, JoinColumn, OneToMany, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntite, EntiteStatique, FiltrableEntiteStatique, Fournisseur } from '.';
import ActiviteProduit from './activite-produit.entity';
import { HistoriquePrixProduit } from './historique-prix-produit.entity';
import { ModeleHoraire } from './modele-horaire.entity';
import { ModeleHoraireProduit } from './modele-horaire-produit.entity';

@FiltrableEntiteStatique<Produit>()
@EntiteStatique()
@Entity('produit')
export class Produit implements BaseEntite {
    static key = 'produits';

    static non_privileged_properties: (keyof Produit)[] = [];
    static regular_privileged_properties: (keyof Produit)[] = ['id', 'name'];
    static admin_privileged_properties: (keyof Produit)[] = [];

    @PrimaryGeneratedColumn()
    id: number;

    @Column({ nullable: true })
    fk_id_fournisseur: number;

    @Column({ type: 'text' })
    name = '';

    @Column({ type: 'text', nullable: true })
    description_produit = '';

    @Column({ name: 'b_actif', nullable: true, default: true })
    actif: boolean;

    @Column({ nullable: true })
    notes_internes: string;

    @Column({ nullable: true })
    notes_fournisseur: string;

    @Column({ nullable: true })
    notes_client: string;

    @Column({ type: 'timestamp', nullable: true })
    created_at = '';

    @Column({ type: 'timestamp', nullable: true })
    date_derniere_modification = '';

    @ManyToOne(() => Fournisseur)
    @JoinColumn({ name: 'fk_id_fournisseur', referencedColumnName: 'id' })
    fournisseur: Fournisseur;
    @OneToMany(() => ActiviteProduit, (activite_produit: ActiviteProduit) => activite_produit.produit, {
        cascade: true,
    })
    activiteProduits: ActiviteProduit[];

    @OneToMany(
        () => HistoriquePrixProduit,
        (historique_prix_produit: HistoriquePrixProduit) => historique_prix_produit.produit,
        { cascade: true },
    )
    historique_prix_produit: HistoriquePrixProduit[];

    @Column({ nullable: true })
    fk_id_horaire_par_defaut: number;

    @ManyToOne(() => ModeleHoraire)
    @JoinColumn({ name: 'fk_id_horaire_par_defaut', referencedColumnName: 'id' })
    horaireParDefaut: ModeleHoraire;

    @OneToMany(
        () => ModeleHoraireProduit,
        (modeleHoraireProduit: ModeleHoraireProduit) => modeleHoraireProduit.produit,
        {
            cascade: true,
        },
    )
    modelesHorairesProduit: ModeleHoraireProduit[];

    @BeforeInsert()
    updateCreatedAt(): void {
        this.created_at = new Date().toUTCString();
    }
}
